export class GlobalButtonStyle {
  color = 'uk-button-primary';
  textColor = '';
  size = '';
  borderRadius = 0;
  borderColor = 'tb-border-transparent';
  borderWidth = 'tb-border-remove';
  boxShadow = '';
  hoverBoxShadow = '';
  horizontalPadding = '';
  useGlobalStyles = false;

  static normalize(styles?: Partial<GlobalButtonStyle>): GlobalButtonStyle {
    const globalButtonStyle = new GlobalButtonStyle();

    globalButtonStyle.color = styles?.color ?? globalButtonStyle.color;
    globalButtonStyle.textColor = styles?.textColor ?? globalButtonStyle.textColor;
    globalButtonStyle.size = styles?.size ?? globalButtonStyle.size;
    globalButtonStyle.borderRadius = styles?.borderRadius ?? globalButtonStyle.borderRadius;
    globalButtonStyle.borderColor = styles?.borderColor ?? globalButtonStyle.borderColor;
    globalButtonStyle.borderWidth = styles?.borderWidth ?? globalButtonStyle.borderWidth;
    globalButtonStyle.boxShadow = styles?.boxShadow ?? globalButtonStyle.boxShadow;
    globalButtonStyle.hoverBoxShadow = styles?.hoverBoxShadow ?? globalButtonStyle.hoverBoxShadow;
    globalButtonStyle.horizontalPadding = styles?.horizontalPadding ?? globalButtonStyle.horizontalPadding;
    globalButtonStyle.useGlobalStyles = styles?.useGlobalStyles ?? globalButtonStyle.useGlobalStyles;

    return globalButtonStyle;
  }
}
